function Chevron(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18 10l-1.41-1.41L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#A8ADB2" />
    </svg>
  )
}

export default Chevron
